import { useState } from '@wordpress/element';
import { Icon } from '@wordpress/components';

const Accordion = ( { tabs = [] } ) => {
	const [ { currentTab }, setState ] = useState( {
		currentTab: false,
	} );

	return <div className="gutenify-accordion-wrapper">
		{ tabs.map( ( tab ) => {
			const Label = tab.label;
			const isActive = ( currentTab === tab.name );
			let classnames = 'gutenify-accordion-item';
			classnames += isActive ? ' gutenify-accordion-item-active' : '';
			return <div className={ classnames } key={ `gutenify-accordion-item-${ tab.name }` }>
				<button onClick={ () => {
					setState( {
						currentTab: currentTab === tab.name ? '' : tab.name,
					} );
				} } className={ 'gutenify-accordion-item-heading' }>
					<div className="gutenify-accordion-item-heading-arrow"><Icon icon={ isActive ? 'arrow-down-alt2' : 'arrow-right-alt2' } /></div>
					<div className="gutenify-accordion-item-label"><Label /></div>
				</button>
				<div className={ `gutenify-accordion-item-content` }> { tab.cb() }</div>
			</div>;
		} ) }
	</div>;
};

export default Accordion;
